/* eslint-disable no-useless-escape */
import React, { useState, useEffect, useRef } from "react";
import { Tooltip } from "antd";

import { connect } from "react-redux";
import moment from "moment";
import Linkify from "react-linkify";
import { pathOr } from "ramda";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import {
  chatMessageSagaAction,
  activePatientSagaAction,
  chatpatient,
  PatientCountAction,
  unClaimedPatientSagaAction,
  queuedPatientsSagaAction,
  otherPatientSagaAction,
} from "../../../../sagas/saga-actions";
import { claimedPatientByUser } from "../../../../sagas/saga-claimedUser";
import {
  urls,
  MOBILE_WIDTH,
  LANGUAGE_FULLFORMS,
} from "../../../../constants/constants";
import { setPopup } from "../../../../actions/popupAction";
import { shiftPatientTopSagaAction } from "../../../../sagas/saga-actions";
import { updateMessageStatusSagaAction } from "../../../../sagas/saga-loadChat";
import loginService from "../../../../service/login";
import CommonService from "../../../../service/CommonService";
import { getStandardTime } from "../../../../helper/helpers";

import {
  CheckIcon,
  FailedIcon,
  SMSIcon,
  IVRIcon,
  secureMsgIcon,
  secureLinkIcon,
  unencryptedMsgIcon,
  rcsLivechatIcon,
} from "../../../../assets/svg";
import "./chat.scss";
import ChatInner from "./chatInner";
import LiveChatService from "../../../../service/LiveChatService";
import useWindowDimensions from "../../../../components/custom-hooks/useWindowDimensions";
import { ENGLISH_ONLY_INPUT_REGEX } from "../../../../utilities/regex";

const commonService = new CommonService();
const liveChatService = new LiveChatService();
const ENGLISH_ONLY_INPUT_MESSAGE =
  "Only English characters are allowed when auto-translation is enabled.";

const obj = {
  userId: 1,
  patientId: 1,
  messageBody: "hi",
  conversationType: "outbound",
  msgType: "conversation",
  senderNo: loginService.getTextingNumber(),
  rcsChannelName: loginService.getRcsChannelName(),
  practiceId: "",
  ehr: "",
};

const statusIconMap = {
  delivered: <CheckIcon success />,
  sent: <CheckIcon />,
  failed: FailedIcon,
};

const Chat = (props) => {
  const {
    history,
    user,
    patients,
    activePatient,
    unClaimed,
    queuedPatient,
    otherPatients,
    activeChatPatientNumber,
    activePatientSaga,
    unClaimedPatientSaga,
    queuedPatientsSaga,
    Sound,
    PatientCount,
    showChat,
    setPopup,
    textInputRef,
    transferNumberState = false,
    releaseNumberState = false,
    setMainState,
    selectedTagId = null,
  } = props;

  const [state, setState] = useState({
    messages: [],
    value: "",
    checkingProps: "",
    hasMore: true,
    goBottom: false,
    chatUpdated: false,
    currentUser: "",
    page: 0,
    allowTyping: true,
    claimedPopup: false,
    sendLink: false,
    uploadLink: null,
    quickReplyModal: false,
    quickReplyList: [],
    activateSecureChat: false,
    deactivateSecureChat: false,
    secureSessionIsActive: false,
    endSecureSessionChat: false,
    secureTimeSession: false,
    showSecureTimePopUp: false,
    showSecureTimeMsg: "",
    secureChatLinkStatus: false,
    activeSpellCheck: true,
    secureChatLink: "",
    secureSessionId: "",
    isApiLoading: false,
    translationToggles: {},
    detectedLanguage: "",
  });
  const [secureRecevieChatDetails, setSecureRecevieChatDetails] = useState("");

  const [spellSuggestionState, setSuggestionState] = useState({
    x: null,
    y: null,
    opened: false,
    wordId: null,
    selectedSuggestions: [],
    suggestions: [],
  });

  const [
    isNewMessageNotificationVisible,
    setIsNewMessageNotificationVisible,
  ] = useState(false);

  // 🔁 REPLACED spellCheckWait state with a ref lock
  const spellCheckLock = useRef(false);

  const [translationPreview, setTranslationPreview] = useState("");
  const [translationConfidence, setTranslationConfidence] = useState(null);
  const [detectedLanguage, setDetectedLanguage] = useState("");
  const [isTranslating, setIsTranslating] = useState(false);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const sendMessageRef = useRef();
  const sendLinkRef = useRef();
  const scrollRef = useRef();
  const inFlightLoadRef = useRef("");
  const translationRequestRef = useRef(0);
  const canAutoTranslateRef = useRef(false);
  const [ignoredWords, setIgnoredWords] = useState([]);
  const { width } = useWindowDimensions();

  const isTranslationFeatureEnabled =
    typeof loginService.getEnableTranslation === "function"
      ? loginService.getEnableTranslation()
      : false;
  const [isAutoTranslationEnabled, setIsAutoTranslationEnabled] = useState(
    isTranslationFeatureEnabled,
  );
  const autoTranslationPreferenceRef = useRef(isTranslationFeatureEnabled);
  const canAutoTranslate =
    isTranslationFeatureEnabled &&
    isAutoTranslationEnabled === true &&
    !state.secureSessionIsActive;
  // const sanitizeEnglishText = (text = "") => text.replace(/[^\x00-\x7F]/g, "");

  useEffect(
    () => {
      canAutoTranslateRef.current = canAutoTranslate;
    },
    [canAutoTranslate],
  );

  useEffect(
    () => {
      if (typeof isAutoTranslationEnabled === "boolean") {
        autoTranslationPreferenceRef.current = isAutoTranslationEnabled;
      }
    },
    [isAutoTranslationEnabled],
  );

  useEffect(
    () => {
      if (state.secureSessionIsActive) {
        translationRequestRef.current += 1;
        if (typingTimeout) {
          clearTimeout(typingTimeout);
          setTypingTimeout(null);
        }
        setIsTranslating(false);
        setTranslationPreview("");
        setTranslationConfidence(null);
        setDetectedLanguage(null);
        setIsAutoTranslationEnabled(null);
        canAutoTranslateRef.current = false;
        return;
      }

      if (isAutoTranslationEnabled === null) {
        const restoredAutoTranslationValue =
          autoTranslationPreferenceRef.current;
        setIsAutoTranslationEnabled(restoredAutoTranslationValue);
        canAutoTranslateRef.current = restoredAutoTranslationValue;
      }
    },
    [state.secureSessionIsActive],
  );

  const endSecureSession = (data) => {
    const practiceId = props?.user?.practiceId;
    const patientId = props?.patients?.patient?.id;

    if (practiceId === data.practiceId && patientId === data.patientId) {
      setState((st) => ({ ...st, endSecureSessionChat: true }));
    }
  };

  const linkNotClicked = (data) => {
    const practiceId = props?.user?.practiceId;
    const patientId = props?.patients?.patient?.id;
    if (practiceId === data.practiceId && patientId === data.patientId) {
      setState((st) => ({ ...st, secureChatLinkStatus: true }));
    }
  };

  const isEmpty = (o) => {
    return !(o && Object.keys(o).length);
  };

  // update message status
  const updateSentMessageStatus = ({ msg }) => {
    if (!msg || user.practiceId !== msg.practiceId) {
      return;
    }
    if (msg) {
      setState((st) => {
        const { messages } = st;
        if (messages.length && messages.filter((e) => e.id === msg.id).length) {
          const newMessages = st.messages.map((message) => {
            if (message.patient) {
              if (
                message.patient.id === msg.patientId &&
                message.id === msg.id
              ) {
                message.twilioMsgStatus = msg.twilioMsgStatus;
              }
            } else {
              if (
                message.patientId === msg.patientId &&
                message.id === msg.id
              ) {
                message.twilioMsgStatus = msg.twilioMsgStatus;
              }
            }

            return message;
          });
          return {
            ...st,
            messages: [...newMessages],
          };
        } else if (
          msg.userId === props.user.id &&
          activeChatPatientNumber === msg.recipientNo
        ) {
          return {
            ...st,
            messages: [...st.messages, msg],
          };
        } else {
          return st;
        }
      });
    }
  };

  const fetchTranslationPreview = async (text, { force = false } = {}) => {
    const requestId = translationRequestRef.current + 1;
    translationRequestRef.current = requestId;

    if (!text || !text.trim()) {
      setTranslationPreview("");
      setTranslationConfidence(null);
      setIsTranslating(false);
      return;
    }
    if (!force && !canAutoTranslateRef.current) {
      setTranslationPreview("");
      setTranslationConfidence(null);
      setIsTranslating(false);
      return;
    }
    if (!isValidDetectedLanguage(detectedLanguage)) {
      setTranslationPreview("");
      setTranslationConfidence(null);
      setIsTranslating(false);
      return;
    }

    setIsTranslating(true);
    try {
      const result = await liveChatService.translateMessage(
        text,
        detectedLanguage,
      );
      if (
        requestId !== translationRequestRef.current ||
        !canAutoTranslateRef.current
      ) {
        return;
      }
      setTranslationPreview(result?.data?.translation || "");
      const rawConfidence = result?.data?.confidence;
      if (rawConfidence === undefined || rawConfidence === null || rawConfidence === "") {
        setTranslationConfidence(null);
      } else {
        const parsedConfidence = Number(rawConfidence);
        setTranslationConfidence(
          Number.isFinite(parsedConfidence) ? parsedConfidence : null,
        );
      }
      const targetLanguage =
        result?.data?.targetLanguage?.toLowerCase?.() || "";
      if (isValidDetectedLanguage(targetLanguage)) {
        setDetectedLanguage(targetLanguage);
      } else {
        setDetectedLanguage("");
      }
    } catch (err) {
      setPopup({
        customPopupMessage: true,
        messageType: "error",
        message: pathOr(
          "Unable to process message translation at this time.",
          ["response", "data", ""],
          err,
        ),
      });
      if (requestId !== translationRequestRef.current) {
        return;
      }
      setTranslationPreview("");
      setTranslationConfidence(null);
      setDetectedLanguage("");
    } finally {
      if (requestId === translationRequestRef.current) {
        setIsTranslating(false);
      }
    }
  };

  const handleAutoTranslationToggle = (value) => {
    setIsAutoTranslationEnabled(value);
    canAutoTranslateRef.current = value;

    if (!value) {
      translationRequestRef.current += 1;
      if (typingTimeout) {
        clearTimeout(typingTimeout);
        setTypingTimeout(null);
      }
      setIsTranslating(false);
      setTranslationPreview("");
      setTranslationConfidence(null);
      return;
    }

    const text = textInputRef?.current?.innerText || state?.value || "";
    if (text.trim() && isValidDetectedLanguage(detectedLanguage, true)) {
      fetchTranslationPreview(text, { force: true });
    }
  };

  useEffect(
    () => {
      receiveTextMessageFromSocket(secureRecevieChatDetails, state);
    },
    [secureRecevieChatDetails],
  );

  useEffect(() => {
    const token = loginService.getToken();

    const addSentMessageToState = (e) => {
      const data = e.detail.data;
      const originalMessage = e.detail.originalMessage || {};
      if (!data || user?.practiceId !== data?.practiceId) {
        return;
      }
      Sound.send();
      if (!data?.twilioMsgStatus) {
        data.twilioMsgStatus = undefined;
      }

      const mergedMessage = {
        ...data,
        originalBody:
          data.originalBody ||
          data.originalMessageBody ||
          data.orignalMessageBody ||
          originalMessage.originalBody ||
          originalMessage.originalMessageBody,
        originalMessageBody:
          data.originalMessageBody ||
          data.orignalMessageBody ||
          originalMessage.originalMessageBody ||
          originalMessage.originalBody,
        translatedText:
          data.translatedText || originalMessage.translatedText || undefined,
        detectedLanguage:
          data.detectedLanguage ||
          originalMessage.detectedLanguage ||
          undefined,
        confidence:
          data.confidence !== undefined && data.confidence !== null
            ? data.confidence
            : originalMessage.confidence !== undefined
              ? originalMessage.confidence
              : undefined,
      };

      setState((st) => ({
        ...st,
        messages: [...st.messages, mergedMessage],
        uploadLink: null,
        secureChatLink: "",
      }));
      setTranslationPreview("");
      setTranslationConfidence(null);
      setIsTranslating(false);
      sendMessageRef.current = false;
      scrollToBottom();
    };

    if (!token) {
      history.push("/login");
    }

    localStorage.removeItem("ehr");

    // socket event listener for socket service
    window.addEventListener(
      "addSentMessageToState",
      addSentMessageToState,
      false,
    );

    // socket event listener for socket service
    window.addEventListener(
      "receiveTextMessageFromSocket",
      (e) => {
        setSecureRecevieChatDetails(e.detail);
      },
      false,
    );

    // socket event listener for socket service
    window.addEventListener(
      "updateSentMessageStatus",
      (e) => {
        updateSentMessageStatus(e.detail);
      },
      false,
    );

    // socket event listener for socket service
    window.addEventListener("linkNotClicked", (e) => {
      linkNotClicked(e.detail);
    });

    // socket event listener for socket service
    window.addEventListener(
      "endSecureSession",
      (e) => {
        endSecureSession(e.detail);
      },
      false,
    );

    getQuickReplyList();

    return () => {
      window.removeEventListener(
        "addSentMessageToState",
        addSentMessageToState,
      );

      window.removeEventListener("linkNotClicked", linkNotClicked);

      window.removeEventListener(
        "updateSentMessageStatus",
        updateSentMessageStatus,
      );
      window.removeEventListener("endSecureSession", endSecureSession);
    };
  }, []);

  const updatePatientList = (currentUser, msg) => {
    if (!msg || currentUser.practiceId !== msg.practiceId) {
      return;
    }
    const sidenav = { offset: 0, userId: currentUser.id, tag: selectedTagId };

    const tabSet = localStorage.getItem("tabSet");

    if (tabSet === "activeItem") {
      activePatientSaga(sidenav);
    }

    if (tabSet === "unClaimedItem") {
      unClaimedPatientSaga(sidenav);
    }

    if (tabSet === "queuedItem") {
      queuedPatientsSaga(sidenav);
    }
  };

  const getNewChat = () => {
    const { patient } = patients;
    const currentChatUser = patient || {};
    const activeList = activePatient.activePatientList || [];
    const unClaimedList = unClaimed.unclaimedPatientList || [];
    const queuedPatientList = queuedPatient.queuedPatientList || [];
    const otherList = otherPatients?.otherPatientList?.rows || [];

    const currentValue = activeList.length
      ? activeList.filter((user, index) => user.id === currentChatUser.id)
      : [];
    const currentUnClaimedValue = unClaimedList.length
      ? unClaimedList.filter((user, index) => user.id === currentChatUser.id)
      : [];

    const currentQueuedValue = queuedPatientList.length
      ? queuedPatientList.filter(
          (user, index) => user.id === currentChatUser.id,
        )
      : [];

    let currentOtherValue;

    for (let i = 0; i < otherList?.length; i++) {
      const currPatients = otherList[i]?.patients || [];
      currentOtherValue = currPatients.filter(
        (item, index) => item.id === currentChatUser.id,
      );
      if (currentOtherValue.length > 0) break;
    }
    if (
      currentValue &&
      currentValue[0] &&
      currentValue[0].id !== state.currentUser
    ) {
      setState((st) => ({
        ...st,
        messages: [],
        chatUpdated: false,
        hasMore: true,
        currentUser: currentValue[0].id,
        page: 0,
      }));
    } else if (
      currentUnClaimedValue &&
      currentUnClaimedValue[0] &&
      currentUnClaimedValue[0].id !== state.currentUser
    ) {
      setState((st) => ({
        ...st,
        messages: [],
        chatUpdated: false,
        hasMore: true,
        currentUser: currentUnClaimedValue[0].id,
        page: 0,
      }));
    } else if (
      currentQueuedValue &&
      currentQueuedValue[0] &&
      currentQueuedValue[0].id !== state.currentUser
    ) {
      setState((st) => ({
        ...st,
        messages: [],
        chatUpdated: false,
        hasMore: true,
        currentUser: currentQueuedValue[0].id,
        page: 0,
      }));
    } else if (
      currentOtherValue &&
      currentOtherValue[0] &&
      currentOtherValue[0].id !== state.currentUser
    ) {
      setState((st) => ({
        ...st,
        messages: [],
        chatUpdated: false,
        hasMore: true,
        currentUser: currentOtherValue[0].id,
        page: 0,
      }));
      setDetectedLanguage("");
    }

    return null;
  };

  useEffect(
    () => {
      getNewChat();
    },
    [user, patients, activePatient, unClaimed, queuedPatient],
  );

  const handleChange = (e) => {
    e.persist();
    setSuggestionState({
      x: null,
      y: null,
      opened: false,
      wordId: null,
      selectedSuggestions: [],
      suggestions: [],
    });
    let text = e?.target?.innerText || "";

    if (canAutoTranslate && !ENGLISH_ONLY_INPUT_REGEX.test(text)) {
      if (e?.target) {
        e.target.innerText = state?.value || "";
      }
      setPopup({
        customPopupMessage: true,
        messageType: "error",
        message: ENGLISH_ONLY_INPUT_MESSAGE,
      });
      return;
    }

    setState((st) => ({
      ...st,
      postVal: text,
      value: text,
    }));

    // Debounce translation API call
    if (typingTimeout) clearTimeout(typingTimeout);
    if (!text || !text.trim()) {
      // translationRequestRef.current += 1;
      setIsTranslating(false);
      setTranslationPreview("");
      setTranslationConfidence(null);
      return;
    }

    if (canAutoTranslate && isValidDetectedLanguage(detectedLanguage, true)) {
      setIsTranslating(true);
      setTypingTimeout(
        setTimeout(() => {
          fetchTranslationPreview(text);
        }, 500), // 0.5 second after stop typing
      );
    } else {
      // translationRequestRef.current += 1;
      setIsTranslating(false);
      setTranslationPreview("");
      setTranslationConfidence(null);
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text/plain");

    if (canAutoTranslate && !ENGLISH_ONLY_INPUT_REGEX.test(pastedText)) {
      setPopup({
        customPopupMessage: true,
        messageType: "error",
        message: ENGLISH_ONLY_INPUT_MESSAGE,
      });
      return;
    }

    document.execCommand("insertText", false, pastedText);
  };

  const handleSendLinkModal = () => {
    setState((st) => ({
      ...st,
      sendLink: true,
    }));
  };

  const closeSendLinkModal = () => {
    setState((st) => ({
      ...st,
      sendLink: false,
    }));
  };

  const handleSendLink = async () => {
    const id = state.currentUser;
    if (!sendLinkRef.current) {
      sendLinkRef.current = true;
      const apiData = await commonService.chatSendLink(id);
      if (apiData.msg === "success") {
        setState((st) => ({
          ...st,
          sendLink: false,
          uploadLink: apiData.uploadLink,
        }));
        sendLinkRef.current = false;
      }
    }
  };

  const handlspellCheck = (value) => {
    setState((st) => ({
      ...st,
      activeSpellCheck: value,
    }));
  };

  const normalizeSuggestions = (suggestions = []) => {
    const normalizedSuggestions = [];
    const suggestionsList = Array.isArray(suggestions)
      ? suggestions
      : [suggestions];

    suggestionsList.forEach((suggestion) => {
      if (typeof suggestion === "string" || typeof suggestion === "number") {
        normalizedSuggestions.push(String(suggestion));
        return;
      }

      if (!suggestion || typeof suggestion !== "object") {
        return;
      }

      const suggestionText =
        suggestion.suggestion ||
        suggestion.value ||
        suggestion.word ||
        suggestion.text;

      if (
        typeof suggestionText === "string" ||
        typeof suggestionText === "number"
      ) {
        normalizedSuggestions.push(String(suggestionText));
      }
    });

    return [
      ...new Set(
        normalizedSuggestions.map((item) => item.trim()).filter(Boolean),
      ),
    ];
  };

  const openSuggestions = (event, selectedWord, result) => {
    const suggestionObj = (Array.isArray(result) ? result : []).find(
      (data) =>
        data.misspelledWord === selectedWord ||
        data.unFilteredWord === selectedWord,
    );

    setSuggestionState({
      x: event.pageX - 30,
      y: event.pageY - 300,
      opened: true,
      wordId: event,
      suggestions: normalizeSuggestions(suggestionObj?.suggestions || []),
    });
  };

  // 🔁 FIXED: replaced state flag with ref lock
  const checkForSpellings = async () => {
    // If a spell check is already running, return early (prevents overlapping)
    if (spellCheckLock.current) {
      return true; // treat as "no misspelled words found" to avoid blocking send
    }

    spellCheckLock.current = true;

    try {
      let hasMisspelledWord = true;

      let outp = textInputRef.current;
      outp.innerHTML = outp.innerText;
      const result = await liveChatService.getSpellingSuggestions({
        data: outp.innerText.trim(),
      });
      hasMisspelledWord = result?.data?.some(
        (word) =>
          word.misspelled &&
          !ignoredWords.includes(word.misspelledWord) &&
          !ignoredWords.includes(word.unFilteredWord),
      );
      const spellingMistakes = [];
      result.data.forEach((data) => {
        if (
          data.misspelled &&
          !ignoredWords.includes(data.misspelledWord) &&
          !ignoredWords.includes(data.unFilteredWord)
        ) {
          spellingMistakes.push(data.misspelledWord);
          spellingMistakes.push(data.unFilteredWord);
        }
      });
      const setSpell = [...new Set(spellingMistakes)];
      setSpell.forEach((word, index) => {
        const text = outp.innerHTML;
        let newText;
        const newWord = word.replace(
          /[0-9`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,
          "_",
        );
        if (
          outp.outerHTML.indexOf(
            `<div style="background-color: 
            #ebc7ce; padding: 0.2rem; border-radius: 2px; display: inline-block" class="${newWord}uniqclass_${index}" title="spellcheck" contentEditable="true">${word}</div>`,
          ) === -1 &&
          outp.innerHTML.includes(word)
        ) {
          let specialCharPresent = false;
          const specialRegex = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;

          if (specialRegex.test(word)) {
            specialCharPresent = true;
          } else {
            specialCharPresent = false;
          }
          newText = text.replace(
            specialCharPresent ? word : new RegExp(word, "g"),
            `<div style='background-color: 
            #ebc7ce; padding: 0.2rem; border-radius: 2px; display: inline-block' class="${newWord}uniqclass_${index}" title="spellcheck" contentEditable="true">${word}</div>`,
          );
          outp.innerHTML = newText;
        }
      });

      setSpell.forEach((word, index) => {
        const newWord = word.replace(
          /[0-9`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,
          "_",
        );
        const child = document.querySelectorAll(
          `.${newWord}uniqclass_${index}`,
        );
        child.forEach((item) => {
          item.addEventListener(
            "click",
            function(event) {
              openSuggestions(event, word, result.data);
            },
            false,
          );
          const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
              const element = document.getElementsByClassName(
                `${newWord}uniqclass_${index}`,
              );
              element[0].style.backgroundColor = "";
            });
          });

          const config = {
            childList: true,
            subtree: true,
            characterData: true,
          };

          observer.observe(item, config);
        });
      });
      setSuggestionState((st) => ({
        ...st,
        opened: false,
        wordId: null,
        suggestions: [],
      }));
      return hasMisspelledWord;
    } catch (error) {
      console.error("Spell check failed", error);
      return true; // On error, allow sending
    } finally {
      spellCheckLock.current = false; // Always release lock
    }
  };

  const igonreSpellCheckWord = (word) => {
    setIgnoredWords([...ignoredWords, word]);
  };

  const handleSubmit = async (event, id) => {
    if (event) {
      event.preventDefault();
    }
    let value = "";
    const isQuickReply = !!id;

    if (id) {
      value = await getQuickReplyMsg(id);
    } else if (state.secureChatLink) {
      value = state.secureChatLink;
    } else {
      value = `${state?.value} ${state.uploadLink || ""}`;
    }
    const isSecureLinkMessage =
      !isQuickReply &&
      Boolean(state.secureChatLink) &&
      value === state.secureChatLink;

    if (!value?.trim()?.length) return;
    if (
      !isQuickReply &&
      !isSecureLinkMessage &&
      canAutoTranslate &&
      !ENGLISH_ONLY_INPUT_REGEX.test(state?.value || "")
    ) {
      setPopup({
        customPopupMessage: true,
        messageType: "error",
        message: ENGLISH_ONLY_INPUT_MESSAGE,
      });
      return;
    }
    if (
      !isQuickReply &&
      !isSecureLinkMessage &&
      canAutoTranslate &&
      isValidDetectedLanguage(detectedLanguage) &&
      isTranslating
    ) {
      return;
    }

    const activeArrayList = activePatient?.activePatientList
      ? activePatient.activePatientList
      : [];
    const currentChatUser = patients?.patient ? patients.patient : {};
    if (value !== "") {
      const currentValue = activeArrayList?.filter(
        (user) => user?.id === currentChatUser?.id,
      );

      if (!currentValue[0]) {
        return;
      }

      if (state.secureSessionIsActive) {
        if (state.activeSpellCheck && !state.secureChatLink) {
          const noFoundWrongSpell = await checkForSpellings();
          if (!noFoundWrongSpell) {
            sendWebMessage(currentValue, value, isQuickReply);
          }
        } else {
          state.secureChatLink
            ? sendMessage(currentValue, value, isQuickReply)
            : sendWebMessage(currentValue, value, isQuickReply);
        }
      } else if (state.activeSpellCheck) {
        const noFoundWrongSpell = await checkForSpellings();
        if (!noFoundWrongSpell) {
          sendMessage(currentValue, value, isQuickReply);
        }
      } else {
        sendMessage(currentValue, value, isQuickReply);
      }
    }
  };

  const sendMessage = (currentValue, value, isQuickReply = false) => {
    obj.to = currentValue[0]?.cellPhone;
    let ehrName = user?.practice?.ehrName
      ? user.practice.ehrName.toLowerCase()
      : "";
    obj.from = loginService.getTextingNumber();
    obj.rcsChannelName = loginService.getRcsChannelName();
    obj.isRcsForLivechat = loginService.getIsRcsForLiveChat();
    obj.enableRcs = loginService.getEnableRcs() == 1;
    obj.ehr = ehrName;
    obj.countryCode = currentValue[0]?.countryCode || "+1";

    const originalBody = value.trim();
    const isSecureLinkMessage =
      Boolean(state.secureChatLink) && originalBody === state.secureChatLink;
    // For quick replies, don't include translation data
    const hasTranslation =
      !isQuickReply &&
      !isSecureLinkMessage &&
      canAutoTranslate &&
      translationPreview &&
      translationPreview !== "Translation failed";
    let translatedBody = hasTranslation ? translationPreview : "";
    // Append uploadLink to translated text if both translation and link exist
    if (hasTranslation && state.uploadLink) {
      translatedBody = `${translatedBody} ${state.uploadLink}`;
    }
    // Append secureChatLink to translated text if both translation and link exist
    if (hasTranslation && state.secureChatLink) {
      translatedBody = `${state.secureChatLink}`;
    }
    const messageBody = originalBody;

    const message = {
      ...obj,
      messageBody,
      patientId: currentValue[0]?.id,
      userId: user?.id,
      practiceId: user?.practice?.practiceId || user?.practiceId,
      to: obj.to,
      ...(hasTranslation
        ? {
            translatedText: translatedBody,
            detectedLanguage: detectedLanguage,
            confidence: translationConfidence,
          }
        : {}),
      ...(state.uploadLink ? { sendLinkMessage: true } : {}),
    };
    if (!sendMessageRef.current) {
      sendMessageRef.current = true;
      const sendMessage = new CustomEvent("sendMessage", {
        detail: {
          message,
          originalMessage: {
            originalBody,
            originalMessageBody: originalBody,
            translatedText: hasTranslation ? translatedBody : undefined,
            detectedLanguage: hasTranslation ? detectedLanguage : undefined,
            confidence: hasTranslation ? translationConfidence : undefined,
          },
        },
      });
      window.dispatchEvent(sendMessage);
      setState((st) => ({
        ...st,
        page: 0,
        loadMore: false,
        value: "",
        uploadLink: null,
      }));
      setTranslationPreview("");
      setTranslationConfidence(null);
      setIsTranslating(false);
      setIgnoredWords([]);
      sendMessageRef.current = false;
      if (textInputRef?.current) {
        textInputRef.current.innerText = "";
        textInputRef.current.focus();
      }
    }
  };

  const sendWebMessage = (currentValue, value, isQuickReply = false) => {
    let ehrName = user?.practice?.ehrName
      ? user.practice.ehrName.toLowerCase()
      : "";

    const originalBody = value.trim();
    const isSecureLinkMessage =
      Boolean(state.secureChatLink) && originalBody === state.secureChatLink;
    // For quick replies, don't include translation data
    const hasTranslation =
      !isQuickReply &&
      !isSecureLinkMessage &&
      canAutoTranslate &&
      translationPreview &&
      translationPreview !== "Translation failed";
    let translatedBody = hasTranslation ? translationPreview : "";
    // Append uploadLink to translated text if both translation and link exist
    if (hasTranslation && state.uploadLink) {
      translatedBody = `${translatedBody} ${state.uploadLink}`;
    }
    // Append secureChatLink to translated text if both translation and link exist
    if (hasTranslation && state.secureChatLink) {
      translatedBody = `${state.secureChatLink}`;
    }
    const messageBody = hasTranslation ? translatedBody : originalBody;

    const message = {
      patientId: currentValue[0]?.id,
      sessionId: state.secureSessionId,
      practiceId: user?.practice?.practiceId || user?.practiceId,
      ehrName,
      userId: user?.id,
      messageBody,
      ...(hasTranslation
        ? {
            translatedText: translatedBody,
            detectedLanguage: detectedLanguage,
            confidence: translationConfidence,
          }
        : {}),
      ...(state.uploadLink ? { sendLinkMessage: true } : {}),
    };

    if (!sendMessageRef.current) {
      sendMessageRef.current = true;
      const sendWebMessage = new CustomEvent("sendWebMessage", {
        detail: {
          message,
          originalMessage: {
            originalBody,
            originalMessageBody: originalBody,
            translatedText: hasTranslation ? translatedBody : undefined,
            detectedLanguage: hasTranslation ? detectedLanguage : undefined,
            confidence: hasTranslation ? translationConfidence : undefined,
          },
        },
      });
      window.dispatchEvent(sendWebMessage);
      setState((st) => ({
        ...st,
        page: 0,
        loadMore: false,
        value: "",
        uploadLink: null,
      }));
      sendMessageRef.current = false;
      setTranslationPreview("");
      setTranslationConfidence(null);
      setIsTranslating(false);
      if (textInputRef?.current) {
        textInputRef.current.innerText = "";
        textInputRef.current.focus();
      }
    }
  };

  // receive message status from Socket service
  const receiveTextMessageFromSocket = ({ msg }, newState) => {
    if (!msg || user.practiceId !== msg.practiceId) {
      return;
    }
    if (msg !== null && msg !== "sent" && msg !== "delivered" && msg) {
      const { messages } = newState;

      const { patient } = patients;
      // Only update detectedLanguage for inbound messages with msgType="conversation"
      // For outbound messages or secure chat messages (webMessage), preserve the existing detectedLanguage
      if (
        msg.conversationType === "inbound" &&
        (msg.msgType === "conversation" || !msg.msgType)
      ) {
        if (
          msg.detectedLanguage &&
          msg.detectedLanguage.toLowerCase() !== "error" &&
          msg.detectedLanguage.toLowerCase() !== "tlerr"
        ) {
          const normalizedLanguage = msg.detectedLanguage.toLowerCase();
          if (isValidDetectedLanguage(normalizedLanguage, true)) {
            setDetectedLanguage(normalizedLanguage);
          } else {
            setDetectedLanguage("");
          }
        } else {
          // Clear detectedLanguage only if inbound message doesn't have valid detectedLanguage
          setDetectedLanguage("");
        }
      }

      // avoid adding the message sent by the user in the same chat window
      if (msg?.userId === user?.id) {
        let exists = false;
        messages.forEach((item) => {
          if (item.id === msg.id) {
            exists = true;
            return;
          }
        });
        if (exists) {
          return;
        } else if (msg.sendLinkMessage) {
          let currentEhrName =
            user && user.practice && user.practice.ehrName
              ? user.practice.ehrName.toLowerCase()
              : "";
          obj.senderNo = loginService.getTextingNumber();
          obj.ehr = currentEhrName;
          let newMessage = {
            ...obj,
            createdAt: msg?.createdAt,
            messageBody: msg.messageBody,
            conversationType: msg.conversationType,
            patientId: msg.patientId,
            senderNo: msg.senderNo ? msg.senderNo : null,
            recipientNo: msg.recipientNo,
            user: msg.user,
            id: msg.id,
            originalMessageBody:
              msg && msg.originalMessageBody
                ? msg.originalMessageBody
                : msg && msg.originalBody
                  ? msg.originalBody
                  : msg && msg.orignalMessageBody
                    ? msg.orignalMessageBody
                    : undefined,
            detectedLanguage: msg && msg.detectedLanguage,
          };
          messages.push(newMessage);
          setState((st) => ({
            ...st,
            page: 0,
            loadMore: false,
            messages: [...messages],
          }));
          scrollToBottom();
          return;
        }
      }

      let id = "";
      PatientCount();
      if (isEmpty(patient) === false) {
        id = patient.id;
      }
      let ehrName =
        user && user.practice && user.practice.ehrName
          ? user.practice.ehrName.toLowerCase()
          : "";
      obj.senderNo = loginService.getTextingNumber();
      obj.ehr = ehrName;
      let message = {
        ...obj,
        createdAt: msg?.createdAt,
        messageBody: msg.messageBody,
        conversationType: msg.conversationType,
        patientId: msg.patientId,
        senderNo: msg.senderNo ? msg.senderNo : null,
        recipientNo: msg.recipientNo ? msg.recipientNo : null,
        user: msg.user,
        id: msg.id,
        originalMessageBody:
          msg && msg.originalMessageBody
            ? msg.originalMessageBody
            : msg && msg.originalBody
              ? msg.originalBody
              : msg && msg.orignalMessageBody
                ? msg.orignalMessageBody
                : undefined,
        detectedLanguage: msg && msg.detectedLanguage,
      };

      if (msg.msgType === "webMessage") {
        message.msgType = msg.msgType;
        message.sessionId = msg.sessionId;
        message.createdAt = msg.createdAt;
      }

      const activeList = activePatient.activePatientList || [];

      const patientClaimedForUser = activeList.find(
        (patient) => patient.id === msg.patientId,
      );

      const notificationSoundForUnclaimed = JSON.parse(
        localStorage.getItem("notificationSoundForUnclaimed"),
      );

      if (loginService.isLoggedin()) {
        if (
          (notificationSoundForUnclaimed && !patientClaimedForUser) ||
          patientClaimedForUser
        ) {
          if (msg.conversationType === "inbound") {
            Sound.receive();
          } else {
            Sound.send();
          }
        }
      }

      if (
        patients &&
        patients.patient &&
        id === message.patientId &&
        loginService.isLoggedin()
      ) {
        setIsNewMessageNotificationVisible(true);
        setState((st) => ({
          ...st,
          page: 0,
          loadMore: false,
          messages: [...st.messages, message],
        }));
        const currentObject = { userId: user.id, messageId: msg.id };
        if (showChat) {
          props.updateMessageStatusSagaAction(currentObject);
        }
        updatePatientList(user, msg);
      } else {
        updatePatientList(user, msg);
      }
    }
  };

  const claimedPatient = (data) => {
    props.claimedPatientByUser(data, () => {
      props.PatientCount();
      const event = new Event("refreshCurrentTab");
      window.dispatchEvent(event);
      props.chatPatient({});
    });
    if (width < MOBILE_WIDTH) {
      history.push("/");
    }
  };

  const loadMore = () => {
    let { page } = state;
    const { patient } = patients;
    const patientId = patient && patient.id;

    if (!patientId) {
      setState((st) => ({
        ...st,
        hasMore: false,
        page: page + 1,
      }));
    } else if (page >= 0) {
     
      const requestKey = `${patientId}:${page + 1}`;
      if (inFlightLoadRef.current === requestKey) {
        return;
      }
      inFlightLoadRef.current = requestKey;
      console.info(
        `[Conversation] loadMore → patientId=${patientId} page=${page + 1}`
      );
      const { messages } = state;
      fetch(
        `${urls.aspariaBackend}api/v1/conversation?page=${page +
          1}&size=${15}&patientId=${patientId}&type=${localStorage.getItem(
          "tabSet",
        )}`,
        {
          headers: {
            method: "GET",
            accept: "application/json",
            Authorization: `Bearer `,
            Pragma: "no-cache",
          },
          credentials: "include",
        },
      )
        .then((data) => {
          return data.json();
        })
        .then((result) => {
          if (result && result.length > 0) {
            let newMessages = [...result.reverse(), ...messages];
            const allMessages = [...result, ...messages];
            const latestInboundMessage = allMessages
              .filter(
                (msg) =>
                  msg.conversationType === "inbound" &&
                  (msg.msgType === "conversation" || !msg.msgType),
              )
              .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0];

            if (
              latestInboundMessage &&
              latestInboundMessage.detectedLanguage &&
              latestInboundMessage.detectedLanguage.toLowerCase() !== "error" &&
              latestInboundMessage.detectedLanguage.toLowerCase() !== "tlerr"
            ) {
              const normalizedLanguage = latestInboundMessage.detectedLanguage.toLowerCase();
              if (isValidDetectedLanguage(normalizedLanguage, true)) {
                setDetectedLanguage(normalizedLanguage);
              } else {
                setDetectedLanguage("");
              }
            }
            setState((st) => ({
              ...st,
              messages: newMessages,
              page: page + 1,
            }));
          } else {
            setState((st) => ({
              ...st,
              hasMore: false,
              page: page + 1,
            }));
          }
        })
        .catch((e) => {
         
          setState((st) => ({
            ...st,
            hasMore: false,
          }));
          console.error(
            `[Conversation] loadMore ✗ patientId=${patientId} page=${page + 1}`,
            e
          );
        })
        .finally(() => {
          if (inFlightLoadRef.current === requestKey) {
            inFlightLoadRef.current = "";
          }
        });
    }
  };

  const getMessageItemClassName = (message, index) => {
    let last = state.messages.length - 1;
    let convo = message.conversationType || "inbound";
    let messages = state.messages;
    let className;

    if (convo === "inbound") className = "sent";
    else className = "replies";

    if (
      message.msgType === "webMessage" &&
      state.secureSessionIsActive &&
      state.secureSessionId === message.sessionId
    ) {
      className = `${className} secure-session`;
    }
    let prev = "",
      next = "";
    if (index > 0) prev = messages[index - 1].conversationType || "inbound";
    if (index > 0 && index < last)
      next = messages[index + 1].conversationType || "inbound";

    if (index === 0) return `${className} ${className}-top`;
    else if (prev && convo !== prev) return `${className} ${className}-top`;
    else if (prev && convo === prev && next && convo === next)
      return `${className} ${className}-middle`;
    else if (prev && convo === prev) return `${className} ${className}-last`;
    else if (index === last) return `${className} ${className}-top`;

    return `${className} ${className}-top`;
  };

  const getConversationStatus = (twilioMsgStatus) => {
    if (
      !twilioMsgStatus ||
      twilioMsgStatus === "queued" ||
      twilioMsgStatus === "sent"
    ) {
      return "sent";
    } else if (twilioMsgStatus === "delivered") {
      return "delivered";
    }
    return twilioMsgStatus;
  };

  const getOriginalMessageBody = (message) =>
    message && message.originalMessageBody
      ? message.originalMessageBody
      :  message && message.orignalMessageBody
          ? message.orignalMessageBody
          : undefined;

  const getNormalizedDetectedLanguage = (detectedLanguage) =>
    detectedLanguage ? detectedLanguage.toLowerCase() : "";

  const isValidDetectedLanguage = (lang, includeEnglish = false) => {
    if (!lang || lang === "") {
      return false;
    }
    const normalizedLang = lang.toLowerCase();
    if (!includeEnglish && normalizedLang === "en") {
      return false;
    }
    return Boolean(LANGUAGE_FULLFORMS[normalizedLang]);
  };

  const shouldShowTranslationToggle = (message) => {
    const originalMessageBody = getOriginalMessageBody(message);
    const normalizedLanguage = getNormalizedDetectedLanguage(
      message?.detectedLanguage,
    );

    const hasTranslation =
      message?.conversationType === "inbound"
        ? originalMessageBody &&
          message.messageBody &&
          originalMessageBody !== message.messageBody
        : message.translatedText &&
          message.translatedText !== originalMessageBody;

    return (
      message &&
      (message.conversationType === "inbound" ||
        message.conversationType === "outbound") &&
      Boolean(originalMessageBody) &&
      Boolean(message && message.detectedLanguage) &&
      normalizedLanguage !== "en" &&
      normalizedLanguage !== "tlerr" &&
      normalizedLanguage !== "error" &&
      hasTranslation
    );
  };

  const handleTranslationToggle = (messageKey) => {
    setState((st) => ({
      ...st,
      translationToggles: {
        ...st.translationToggles,
        [messageKey]: !st.translationToggles?.[messageKey],
      },
    }));
  };

  const getDetectedLanguageLabel = (detectedLanguage) => {
    if (!detectedLanguage) return "";
    const normalizedLanguage = getNormalizedDetectedLanguage(detectedLanguage);
    return LANGUAGE_FULLFORMS[normalizedLanguage] || detectedLanguage;
  };

  const getMessageCaption = (message, index) => {
    let caption;
    const convo = message.conversationType || "inbound";

    const twilioMsgStatus =
      convo === "outbound"
        ? getConversationStatus(message.twilioMsgStatus)
        : "";
    const temp =
      message && message.createdAt ? new Date(message.createdAt) : new Date();
    const hh = temp.getHours();
    const min = temp.getMinutes();
    const format = `${hh < 10 ? "0" : ""}${hh}:${min < 10 ? "0" : ""}${min}`;
    const time = getStandardTime(format);
    const isIvr = message?.callDuration;

    const isRcs =
      (message?.senderNo && message?.senderNo?.startsWith("rcs")) ||
      secureRecevieChatDetails?.msg?.senderNo?.startsWith("rcs");

    const channelType = isIvr ? "IVR" : isRcs ? "RCS" : "SMS";
    const channelIcon = isIvr ? IVRIcon : isRcs ? rcsLivechatIcon : SMSIcon;

    const broadCastInfo =
      convo === "outbound" && message.msgType === "broadcast" ? (
        <>
          <span className="broadcast-info">
            <Tooltip placement="top" title={channelType}>
              <span className="channel-icon">{channelIcon}</span>
            </Tooltip>{" "}
            Broadcast Message <span className="separator">-</span>
          </span>
        </>
      ) : (
        <span className="broadcast-info">
          <Tooltip placement="top" title={channelType}>
            <span className="channel-icon">{channelIcon}</span>
          </Tooltip>{" "}
          Chat Message <span className="separator">-</span>
        </span>
      );

    const secureMsg =
      message.msgType === "webMessage" ? (
        <>
          <span className="secure-msg">{secureMsgIcon} Secure</span>
        </>
      ) : (
        ""
      );

    const msgReceivedWhileSecureSession = state.secureSessionIsActive ? (
      <>
        <span className="divider large" />
        <div className="un-encrypted-msg">
          {unencryptedMsgIcon}
          Unencrypted ({`${message?.callDuration ? "IVR" : "SMS"}`})
        </div>
      </>
    ) : (
      <>
        {" "}
        {twilioMsgStatus}{" "}
        <>
          <span className="divider large" />
          <span className={`status ${twilioMsgStatus}`}>
            {twilioMsgStatus}{" "}
            <span className="status-icon">
              {statusIconMap[twilioMsgStatus] || <CheckIcon />}
            </span>
          </span>
        </>
      </>
    );
    caption = secureMsg ? (
      <>
        {time}
        <span className="divider large" />
        {secureMsg}
      </>
    ) : (
      <>
        {broadCastInfo}
        {time}
        {msgReceivedWhileSecureSession}
      </>
    );

    return caption ? <span className="caption">{caption}</span> : null;
  };

  const scrollToBottom = () => {
    if (scrollRef && scrollRef.current) {
      scrollRef.current.scrollIntoView();
    }
    setIsNewMessageNotificationVisible(false);
  };

  const secureChatLinkMsg = () => (
    <div className="secure-chat-link-msg">
      <p>
        Secure session encrypts messages automatically end-to-end.
        <p className="secure-link">
          {secureLinkIcon}
          Join the link to start the secure session
        </p>
      </p>
    </div>
  );

  const displayChat = () => {
    const { messages } = state;
    const dates = [];
    const sessionId = [];

    const partition = (date) => {
      let displayDate = date;
      const yesterday = moment().subtract(1, "day");

      if (moment().isSame(moment(displayDate), "day")) {
        displayDate = "Today";
      } else if (yesterday.isSame(moment(displayDate), "day")) {
        displayDate = "Yesterday";
      } else {
        displayDate = moment(date).format("dddd MMMM DD, YYYY");
      }

      return (
        <div key={displayDate} className="chat-date-partition">
          <p>{displayDate}</p>
        </div>
      );
    };
    const chatComponent = (message, index) => {
      const translationKey = message && message.id ? message.id : null;
      const showTranslationToggle =
        shouldShowTranslationToggle(message) && translationKey;
      const originalMessageBody = getOriginalMessageBody(message);
      const isTranslatedVisible =
        showTranslationToggle && state.translationToggles?.[translationKey];

      const displayedMessageBody = (() => {
        if (!showTranslationToggle)
          return message.messageBody;
         const translatedBody = message.translatedText || message.messageBody;
        if (message.conversationType === "inbound") {
          return isTranslatedVisible ? originalMessageBody : translatedBody;
        }

        return (isTranslatedVisible) ? translatedBody : originalMessageBody;
      })();

      return (
        <li
          key={message.id}
          className={`message-container ${getMessageItemClassName(
            message,
            index,
          )}`}
        >
          <div
            className={`chat-msg ${
              message.conversationType === "outbound" ? "outgoing" : "received"
            }
            `}
          >
            <p
              className={`message-box ${
                message.msgType === "webMessage" ? "secure" : ""
              }
            `}
            >
              {message.conversationType === "outbound" && (
                <section className="sender-name">
                  <span title={message?.user?.userName}>
                    {message?.user?.userName}
                  </span>
                </section>
              )}
              <Linkify
                componentDecorator={(decoratedHref, decoratedText, key) => {
                  const emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g;
                  const urlRegex = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z0-9]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;

                  const isInbound = message?.conversationType === "inbound";

                  const regexToUse = isInbound ? emailRegex : urlRegex;

                  return regexToUse.test(decoratedText) ? (
                    <a target="blank" href={decoratedHref} key={key}>
                      {decoratedText}
                    </a>
                  ) : (
                    decoratedText
                  );
                }}
              >
                {message?.messageBody?.includes("/secured-chat")
                  ? secureChatLinkMsg()
                  : displayedMessageBody}
              </Linkify>

              {showTranslationToggle && (
                <button
                  type="button"
                  className="translation-toggle"
                  onClick={() => handleTranslationToggle(translationKey)}
                >
                  {(() => {
                    if (message.conversationType === "outbound") {
                      return isTranslatedVisible
                        ? "Show in English"
                        : `Show in ${getDetectedLanguageLabel(
                            message.detectedLanguage,
                          )}`;
                    }
                    return isTranslatedVisible
                      ? "Show in English"
                      : `Show in ${getDetectedLanguageLabel(
                          message.detectedLanguage,
                        )}`;
                  })()}
                </button>
              )}
            </p>
            {getMessageCaption(message, index)}
          </div>
        </li>
      );
    };

    const securePartition = (id) => {
      return (
        <div key={id} className="secure-chat-partition">
          <section className="secure-chat-text">
            <p className="title">Secure Chat</p>
            <p className="info">All messages are end-to-end encrypted</p>
          </section>
        </div>
      );
    };

    state.messages = Array.from(new Set(messages.map((a) => a.id))).map(
      (id) => {
        return messages.find((message) => message.id === id);
      },
    );

    return (
      <ul className="chat-messages-list">
        {state.messages &&
          state.messages.map((message, index) => {
            const element = [];
            if (
              message.createdAt &&
              !dates.includes(message.createdAt.slice(0, 10))
            ) {
              dates.push(message.createdAt.slice(0, 10));
              element.push(partition(message.createdAt.slice(0, 10)));
            }

            if (
              message.msgType === "webMessage" &&
              state.secureSessionIsActive &&
              message.sessionId &&
              !sessionId.includes(message.sessionId)
            ) {
              sessionId.push(message.sessionId);
              element.push(securePartition(message.sessionId));
            }
            element.push(chatComponent(message, index));
            return element;
          })}

        <div ref={scrollRef} />
      </ul>
    );
  };

  const getQuickReplyList = async () => {
    try {
      const list = await liveChatService.getQuickReplyList();
      setState((st) => ({
        ...st,
        quickReplyList: list,
      }));
      return list;
    } catch (err) {
      setPopup({
        customPopupMessage: true,
        messageType: "error",
        message: pathOr(
          "Something went wrong",
          ["response", "data", "message"],
          err,
        ),
      });
    }
  };

  const getQuickReplyMsg = async (id) => {
    try {
      const quickMsg = await liveChatService.getQuickReplyById(id);
      return quickMsg.quickMessage;
    } catch (err) {
      setPopup({
        customPopupMessage: true,
        messageType: "error",
        message: pathOr(
          "Something went wrong",
          ["response", "data", "message"],
          err,
        ),
      });
    }
  };

  const handleQuickReply = (value) => {
    setState((st) => ({
      ...st,
      quickReplyModal: true,
    }));
  };

  const handleCancel = () => {
    setState((st) => ({ ...st, claimedPopup: false }));
  };

  const handleHideQuickReply = () => {
    setState((st) => ({
      ...st,
      quickReplyModal: false,
    }));
  };

  const handleChatInput = (e) => {
    setState((st) => ({
      ...st,
      allowTyping: false,
    }));
    handleSubmit(e);
    setTimeout(
      () =>
        setState((st) => ({
          ...st,
          allowTyping: true,
        })),
      2000,
    );
  };

  const handleCloseChatLink = () => {
    setState((st) => ({
      ...st,
      uploadLink: null,
    }));
  };

  const handleClaimButton = () => {
    setState((st) => ({ ...st, claimedPopup: true }));
  };

  const secureLinkClose = () => {
    setState((st) => ({ ...st, secureChatLinkStatus: false }));
  };

  const handleSecureChat = (value) => {
    if (state.secureSessionIsActive && value === false) {
      setState((st) => ({
        ...st,
        deactivateSecureChat: true,
      }));
    } else {
      setState((st) => ({
        ...st,
        activateSecureChat: value,
      }));
    }
  };

  const closeSecureChatModal = () => {
    setState((st) => ({
      ...st,
      activateSecureChat: false,
      deactivateSecureChat: false,
    }));
  };

  const closeSecureChatTime = () => {
    setState((st) => ({
      ...st,
      showSecureTimePopUp: false,
    }));
  };

  const activateSecureSession = async (e) => {
    // Clear translation preview when secure chat is activated
    setTranslationPreview("");
    setTranslationConfidence(null);
    setIsTranslating(false);
    try {
      const patientId = props?.patients?.patient?.id;
      const secureChatLink = await commonService.getSecureChatLink(patientId);
      if (secureChatLink?.success) {
        setState((st) => ({
          ...st,
          secureChatLink: secureChatLink?.data?.securedLink,
          secureSessionId: secureChatLink?.data?.sessionId,
          secureSessionIsActive: true,
          activateSecureChat: false,
          secureTimeSession: true,
        }));
      }
    } catch (err) {
      setState((st) => ({
        ...st,
        activateSecureChat: false,
      }));
      setPopup({
        customPopupMessage: true,
        messageType: "error",
        message: pathOr(
          "Something went wrong",
          ["response", "data", "message"],
          err,
        ),
      });
    }
  };

  const deactivateSecureSession = async () => {
    const sessionId = state.secureSessionId;
    try {
      const endSession = await commonService.endSecureSession(sessionId);
      if (endSession?.data?.success) {
        translationRequestRef.current += 1;
        if (typingTimeout) {
          clearTimeout(typingTimeout);
          setTypingTimeout(null);
        }
        setTranslationPreview("");
        setTranslationConfidence(null);

        // Restore detectedLanguage from the last conversation message (not webMessage)
        const conversationMessages = state.messages.filter(
          (msg) =>
            msg.conversationType === "inbound" &&
            (msg.msgType === "conversation" || !msg.msgType),
        );
        const latestConversationMessage = conversationMessages
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0];

        if (
          latestConversationMessage &&
          latestConversationMessage.detectedLanguage &&
          latestConversationMessage.detectedLanguage.toLowerCase() !== "error" &&
          latestConversationMessage.detectedLanguage.toLowerCase() !== "tlerr"
        ) {
          const normalizedLanguage =
            latestConversationMessage.detectedLanguage.toLowerCase();
          if (isValidDetectedLanguage(normalizedLanguage, true)) {
            setDetectedLanguage(normalizedLanguage);
          }
        }

        setState((st) => ({
          ...st,
          secureSessionIsActive: false,
          deactivateSecureChat: false,
          endSecureSessionChat: false,
          secureTimeSession: false,
          secureSessionId: "",
          value: "",
        }));
      }
      textInputRef.current.innerText = "";
    } catch (err) {
      setState((st) => ({
        ...st,
        deactivateSecureChat: false,
      }));
      setPopup({
        customPopupMessage: true,
        messageType: "error",
        message: pathOr(
          "Something went wrong",
          ["response", "data", "message"],
          err,
        ),
      });
    }
  };

  const sessionTime = async () => {
    const secureChatSessionTime = await commonService.getSecureChatSessionTime();
    if (secureChatSessionTime?.success) {
      setState((st) => ({
        ...st,
        showSecureTimePopUp: true,
        showSecureTimeMsg: secureChatSessionTime?.data,
      }));
    }
  };

  useEffect(
    () => {
      if (state?.secureTimeSession) {
        sessionTime();
      }
      if (state.secureSessionIsActive) {
        setState((st) => ({
          ...st,
          secureChatLink: state.secureChatLink,
        }));
      }
      setMainState((st) => ({
        ...st,
        secureChat: state.secureSessionIsActive,
      }));

      handleSubmit();
    },
    [state.secureSessionIsActive],
  );

  const getSecureSession = async () => {
    const id = patients?.patient?.id;
    setState((st) => ({
      ...st,
      isApiLoading: true,
    }));
    const activeSession = await commonService.getSecureSession(id);
    if (activeSession) {
      setState((st) => ({
        ...st,
        secureSessionIsActive: activeSession?.success,
        secureSessionId: activeSession?.data?.sessionId,
        secureTimeSession: false,
        isApiLoading: false,
      }));
    } else {
      setState((st) => ({
        ...st,
        isApiLoading: false,
      }));
    }
  };
  useEffect(
    () => {
      getSecureSession();
    },
    [patients],
  );

  return (
    <>
      <ChatInner
        chatProps={props}
        chatState={state}
        loadMore={loadMore}
        displayChat={displayChat}
        handleQuickReply={handleQuickReply}
        claimedPatient={claimedPatient}
        handleSendLink={handleSendLink}
        getQuickReplyList={getQuickReplyList}
        handleSubmit={handleSubmit}
        handleChange={handleChange}
        translationPreview={translationPreview}
        detectedLanguage={detectedLanguage}
        isTranslating={isTranslating}
        textInputRef={textInputRef}
        sendMessageRef={sendMessageRef}
        handleSendLinkModal={handleSendLinkModal}
        handleCancel={handleCancel}
        handleHideQuickReply={handleHideQuickReply}
        handleChatInput={handleChatInput}
        handleCloseChatLink={handleCloseChatLink}
        handleClaimButton={handleClaimButton}
        closeSendLinkModal={closeSendLinkModal}
        handleSecureChat={handleSecureChat}
        closeSecureChatModal={closeSecureChatModal}
        closeSecureChatTime={closeSecureChatTime}
        activateSecureSession={activateSecureSession}
        deactivateSecureSession={deactivateSecureSession}
        secureLinkClose={secureLinkClose}
        patient={props?.patients?.patient}
        spellSuggestionState={spellSuggestionState}
        setSuggestionState={setSuggestionState}
        setValueState={setState}
        transferNumberState={transferNumberState}
        setMainState={setMainState}
        releaseNumberState={releaseNumberState}
        handlspellCheck={handlspellCheck}
        igonreSpellCheckWord={igonreSpellCheckWord}
        setIsNewMessageNotificationVisible={setIsNewMessageNotificationVisible}
        isNewMessageNotificationVisible={isNewMessageNotificationVisible}
        scrollToBottom={scrollToBottom}
        activeSpellCheck={state.activeSpellCheck}
        isTranslationEnabled={isTranslationFeatureEnabled}
        isAutoTranslationEnabled={isAutoTranslationEnabled}
        handleAutoTranslationToggle={handleAutoTranslationToggle}
        isEnglishOnlyInput={canAutoTranslate}
        handlePaste={handlePaste}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  patients: state.patients,
  //chat can be removed
  chat: state.chat,
  user: state.login.user,
  activePatient: state.activePatient,
  otherPatients: state.otherPatients,
  unClaimed: state.unClaimed,
  loadChat: state.loadChat,
  queuedPatient: state.queuedPatient,
});

const mapDispatchToProps = (dispatch) => {
  return {
    chatMessageSagaAction: (chat) => {
      dispatch(chatMessageSagaAction(chat));
    },
    claimedPatientByUser: (data, cb) => {
      dispatch(claimedPatientByUser(data, cb));
    },
    activePatientSaga: (data) => {
      dispatch(activePatientSagaAction(data));
    },
    chatPatient: (data) => {
      dispatch(chatpatient(data));
    },
    shiftPatientTopSagaAction: (data) => {
      dispatch(shiftPatientTopSagaAction(data));
    },
    updateMessageStatusSagaAction: (data) => {
      dispatch(updateMessageStatusSagaAction(data));
    },
    PatientCount: () => dispatch(PatientCountAction()),
    unClaimedPatientSaga: (data) => dispatch(unClaimedPatientSagaAction(data)),
    queuedPatientsSaga: (data) => dispatch(queuedPatientsSagaAction(data)),
    otherPatientSagaAction: (data) => dispatch(otherPatientSagaAction(data)),
    setPopup: (data) => dispatch(setPopup(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Chat);
